import { useEffect, useReducer } from 'react';

import { getSettings, setSettings, Settings } from '%services/settings';
import { reducer } from './reducer';

export const DEFAULT_SETTINGS: Settings = {
	notifications: {
		All: true,
		NewPost: true,
		PostLike: true,
		PostComment: true,
		DirectMessage: true,
	},
	security: {
		biometricLock: true,
	},
};

export const useSettings = () => {
	const reducerState = useReducer(reducer, DEFAULT_SETTINGS);
	const [settingsState, dispatch] = reducerState;

	useEffect(() => {
		const loadSettings = async () => {
			const settings = await getSettings();
			if (!settings) {
				return;
			}

			return dispatch({ type: 'LOAD_SETTINGS', payload: settings });
		};

		void loadSettings();
	}, [dispatch]);

	useEffect(() => {
		if (settingsState === DEFAULT_SETTINGS) {
			return;
		}

		void setSettings(settingsState);
	}, [settingsState]);

	return reducerState;
};
